import { FC } from 'react'

import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'
import { Button } from 'shared/ui/button'

import s from './styles.module.scss'

interface PersonActionsProps {
  onCloseCircle: () => void
  onScanPassport: () => void
}

export const PersonActions: FC<PersonActionsProps> = ({
  onCloseCircle,
  onScanPassport,
}) => {
  const { t } = useTranslation()

  return (
    <div className={s.actions}>
      <Button
        type="button"
        variant="opacityBlue"
        className={s.button}
        onClick={onCloseCircle}
      >
        <AppIcon
          id={AllIcons.PERSONS}
          width={20}
          height={20}
          className={s.icon}
        />
        <span className={clsx(s.buttonText, 'semi-bold-14')}>
          {t('insurance.vzr.policyholder.close_circle')}
        </span>
      </Button>

      <Button
        type="button"
        variant="opacityBlue"
        className={s.button}
        onClick={onScanPassport}
      >
        <AppIcon
          id={AllIcons.PASSPORT_SCAN}
          width={20}
          height={20}
          className={s.icon}
        />
        <span className={clsx(s.buttonText, 'semi-bold-14')}>
          {t('insurance.vzr.policyholder.scan_passport')}
        </span>
      </Button>
    </div>
  )
}
